import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import AdaptiveImage from 'components/elements/AdaptiveImage/AdaptiveImage'
import ButtonActivity from 'components/elements/ButtonActivity/ButtonActivity'
import Modal from 'components/interface/Modal/Modal'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'
import MintAccessories from './MintAccessories/MintAccessories'

/**
 * The `ModalMarketplaceCheckout`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalMarketplaceCheckout (props) {
  const { checkoutData, isSingle, product } = props
  const { onAction } = useModalContext()
  const title = useMemo(() => <h1>Checkout</h1>, [])
  const mintData = useRef({
    isSingle,
    checkoutData
  })

  /**
   * The modal footer options
   */
  const options = useMemo(
    () => (
      <>
        <li>
          <ButtonActivity
            type="symbol"
            icon={'close'}
            size="large"
            color="b"
            onClick={() => onAction('close')}
          />
        </li>
      </>
    ),
    []
  )

  return (
    <Modal.Container size="x-small">
      {isSingle && (
        <Modal.Media>
          <AdaptiveImage src={product?.thumbnail} title={name} />
        </Modal.Media>
      )}
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <MintAccessories {...mintData.current} />
      </Modal.Body>
      <Modal.Footer options={[]}>{options}</Modal.Footer>
    </Modal.Container>
  )
}

/** @type {object} */
ModalMarketplaceCheckout.propTypes = {
  isSingle: PropTypes.bool,
  checkoutData: PropTypes.shape().isRequired,
  product: PropTypes.shape({
    thumbnail: PropTypes.string
  })
}

/** @type {object} */
ModalMarketplaceCheckout.defaultProps = {
  isSingle: false,
  product: {}
}

// Memoize
export default memo(ModalMarketplaceCheckout)
